import PropTypes from 'prop-types';
import useStyles from './TabTitle.styles';

/**
 * For usage, see ../TabbedContent.jsx
 */

function TabTitle(props) {
  const classes = useStyles(props);
  return (
    <div
      className={classes.tabTitle}
      data-test={props.isSelected ? 'TabTitle--is-selected' : 'TabTitle'}
      onClick={props.onSelect}
    >
      {props.children}
    </div>
  );
}

TabTitle.propTypes = {
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  children: PropTypes.node.isRequired,
};

TabTitle.defaultProps = {
  isSelected: false,
};

export default TabTitle;
